import type { PromotionOddsBoostInfo } from '@nf/types/account';

const hasOddsBoosterPromotion = (promotionOddsBoostInfo?: PromotionOddsBoostInfo) => {
	return Boolean(
		promotionOddsBoostInfo &&
		(promotionOddsBoostInfo.EnablePromotionOddsBoost || promotionOddsBoostInfo?.EnableAffPromotionOddsBoost) &&
		promotionOddsBoostInfo.GiftOddsBoostTicketCount > 0
	);
};

const shouldShowOddsBoosterGift = (promotionOddsBoostInfo?: PromotionOddsBoostInfo): boolean => {
	return hasOddsBoosterPromotion(promotionOddsBoostInfo) && 
		!promotionOddsBoostInfo?.HasNotify;
};

export const oddsBoosterService = {
	hasOddsBoosterPromotion,
	shouldShowOddsBoosterGift
};